import styled from 'styled-components'
import get from 'lodash/get'
import breakpoint from 'components/breakpoint'

const getDesktopDisplay = ({theme, isLoginApp}) => (theme.config.showRingierBanner && isLoginApp ? 'none' : 'flex')
const hideTenantsOnTablet = ({theme}) => get(theme, 'shell.footer.tenants.hideOn.tablet') && 'none'
const hideTenantsOnDesktop = ({theme}) => get(theme, 'shell.footer.tenants.hideOn.desktop') && 'none'

const FooterBrandsView = styled.div`
  background-color: ${props => props.theme.shell.footer.tenants.backgroundColor};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1024px;
  min-width: 320px;
  width: 100%;
  box-sizing: border-box;
  padding: 24px 20px 36px;

  hr {
    background-color: ${props => props.theme.shell.footer.tenants.separatorColor};
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.portrait}px) {
    padding: 36px 40px;

    hr {
      display: ${getDesktopDisplay};
    }

    > div,
    a:last-child {
      display: ${getDesktopDisplay};
      padding: 0;
    }
  }

  ${breakpoint('portrait')`
    hr {
      display: ${hideTenantsOnTablet};
    }

    > div,
    a:last-child {
      display: ${hideTenantsOnTablet};
      padding: 0;
    }
  `};

  ${breakpoint('desktop')`
    hr {
      display: ${hideTenantsOnDesktop};
    }

    > div,
    a:last-child {
      display: ${hideTenantsOnDesktop};
      padding: 0;
    }
  `};
`

export default FooterBrandsView
